import { sendMsg, SERVICES_REQUEST, ENDPOINT_REQUEST } from "../../configurations";
import { PARAMS } from "../../constants/params";

export const orderServices = {
    getOrderBookService,
    placeOrderService,
    cancelOrderService,
    modifyOrderService,
    getOrderDetailService,
    getOrderFeesService
}

function getOrderBookService(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.GET_ORDER_BOOK, params).get(res => {
        callback(res);
    })
}

function placeOrderService(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.GET_ORDER_BOOK, params).post(res => {
        callback(res);
    })
}

function cancelOrderService(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.CANCEL_ORDER, params).post(res => {
        callback(res);
    })
}

function modifyOrderService(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.MODIFY_ORDER, params).post(res => {
        callback(res);
    })
}

function getOrderDetailService(params, callback) {
    params[PARAMS.ORDER_GROUP_ID] = params[PARAMS.ORDER_GROUP_ID] === '' ? null : params[PARAMS.ORDER_GROUP_ID];
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.GET_ORDER_DETAIL.format(params[PARAMS.ORDER_GROUP_ID]), params).get(res => {
        callback(res);
    })
}

function getOrderFeesService(params, callback) {
    sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.ORDER.GET_ORDER_FEES, params).get(res => {
        callback(res);
    })
}